var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73539 12.8958C5.36669 12.5266 5.1596 12.0262 5.1596 11.5045C5.1596 10.9827 5.36669 10.4823 5.73539 10.1131L13.1592 2.68673C13.5285 2.31756 14.0294 2.11023 14.5516 2.11035C15.0738 2.11047 15.5746 2.31804 15.9438 2.68738C16.3129 3.05673 16.5203 3.5576 16.5201 4.07981C16.52 4.60202 16.3125 5.10279 15.9431 5.47196L9.91062 11.5045L15.9431 17.5369C16.3019 17.9081 16.5006 18.4053 16.4964 18.9216C16.4921 19.4378 16.2853 19.9317 15.9204 20.2969C15.5556 20.6621 15.0619 20.8694 14.5456 20.8741C14.0294 20.8789 13.532 20.6806 13.1605 20.3222L5.73407 12.8971L5.73539 12.8958Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.02aeb0961116ed8abbabc9ad12ffa89d.svg";
export { ForwardRef as ReactComponent };